export default __webpack_public_path__ + "static/media/Rectangle   Rectangle Copy 6   Rectangle Copy 6 Mask.d7f3c2dc.svg";